<style lang="less" scoped>
.service{width: 37%;height: 50%;}
header{width: 100%;height: 15%;background-color: #efeaea;}
article{width: 100%;height: 75%;}
// p{width: 94%;left: 4%;position: absolute;top: 26%;color: gray;}
.num{width: 94%;position: absolute;top: 43%;}
.check{width: 81%;left: 4%;position: absolute;top: 55%;text-align: left;}
.el-checkbox{ margin-bottom: 2%;}
/deep/.el-checkbox__inner {border-radius: 100%;}
.btn{right: 9%;position: absolute;top: 80%;text-align: left;bottom: none;left: none;height: none;
background: none;margin-left: none;background-color: none;}
/deep/.el-progress-bar__innerText{display: none;}
.progressText{position: absolute;top: 18.5%;left: 45%;}
footer{background-color: #efeaea;width: 100%;height: 10%;}
</style>

<template>
<div class="service">
    <div v-show="isShowZX">
        <header>
            <img src="static/zxfw/ic_qi.png" style="position: absolute;left: 4%;top: 2%;" />
              <span style="position: absolute;font-weight: 800;left: 14%;font-size: 25px;color: black;top: 4%;">法律咨询</span>
              <span style="position: absolute;right: 1%;font-size: 25px;color: black;top: 2%;">
                  <i class="el-icon-close" @click="onDisnear"></i>
              </span>
        </header>
        <article>
          <div  v-for="(item,index) in zxfw" :key="index">
          <div v-show="zxfw[index].isshow">
          <el-progress style="width: 94%;left: 4%;position: absolute;top: 18%;" :text-inside="true"  :stroke-width="20" :percentage="Number((index+1)/zxfw.length)*100"></el-progress>
          <div class="progressText">{{ (index + 1) + `/${zxfw.length}` }}</div>
          <p style="width: 94%;left: 4%;position: absolute;top: 26%;color: gray;text-align:left; ">欢迎咨询中国——东盟矿业信息服务平台，为节省您宝贵的时间，并让我们更好地了解您的需求，请完成下列简单的问题（可多选，不选）。</p>
          <!-- <div class="num"><img :src="zxfw[index].ig" /></div> -->
          <p style="width: 94%;left: 4%;position: absolute;top: 45%;text-align: left;">{{zxfw[index].question}}</p>
            <!-- <el-checkbox-group class="check" v-model="checkList"  @change="handleCheckedCitiesChange(value,index)"> -->
            <el-checkbox-group class="check" v-model="checkList">
              <el-checkbox v-for="(ct, index1) in zxfw[index].centry" :key="index1" :label="10*index+index1" :value="ct.value" @change="onSaveData(ct,index)">{{ct.label}}</el-checkbox>
            </el-checkbox-group>
            <!-- <el-checkbox style="position: absolute;top: 70%;left: 64%;" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange(val,index)">不确定</el-checkbox> -->
          <div class="btn">
            <el-button v-show="index!==0" @click="onClicktop(index)">上一题</el-button>
            <el-button v-show="index!==(zxfw.length-1)" @click="onClickBottom(index)">下一题</el-button>
            <el-button v-show="index===(zxfw.length-1)" @click="determine">确定</el-button>
          </div>
          </div>
          </div>
        </article>
        <footer></footer>
    </div>
    <div v-show="isshowLXFS">
      <header>
            <img src="static/zxfw/ic_qi.png" style="position: absolute;left: 4%;top: 2%;" />
              <span style="position: absolute;font-weight: 800;left: 14%;font-size: 25px;color: black;top: 4%;">法律咨询</span>
              <span style="position: absolute;right: 1%;font-size: 25px;color: black;top: 2%;">
                  <i class="el-icon-close" @click="onDisnears"></i>
              </span>
      </header>
      <div>
        <el-form :model="form" style="margin-top: 16%;width: 90%;margin-left: 5%;">
          <el-form-item label="联系方式" :label-width="formLabelWidth">
            <el-input v-model="form.contact" autocomplete="off" style="float:right;width:80%;"></el-input>
          </el-form-item>
          <el-form-item label="具体咨询问题" :label-width="formLabelWidth" style="margin-top:9%;">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入内容"
              v-model="form.jtwt"
              style="float:right;width:80%;">
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="margin-top:10%;">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="submit">提 交</el-button>
        </div>
      </div>
    </div>
</div>

</template>

<script>
export default {
  data()
  {
    return {
      formLabelWidth: '120px',
      zxfw: [],
      checkAll: false,
      isIndeterminate: true,
      dialogZxfwVisible: false,
      checkList: [],
      checkList1: [],
      form: {},
      isShowZX: true,
      isshow: false,
      userPhone: '',
      isshowLXFS: false
    }
  },
  created()
  {
    this.getUserPe()
    this.getdata()
  },
  methods: {
    // 获取需要发送管理员的手机号
    getUserPe()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 117, _exp: 'id>0', orderby: 'id DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.userPhone = ''
        ret.forEach(item =>
        {
          if (item === ret[ret.length - 1])
          
            this.userPhone += item.phone
          else
            this.userPhone += item.phone + ','
        })
      })
    },
    getdata()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 125, _exp: 'id > 0 and type = 2', orderby: 'id ASC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.zxfw = []
        ret.forEach((item, index) =>
        {
          if (index === 0)
          
            this.isshow = true
          
          else
          
            this.isshow = false
          
          let newArr = []
          for (let i = 0; i < item.answer.split(';').length; i++)

            newArr.push({label: item.answer.split(';')[i], value: i})
          this.zxfw.push({centry: newArr, isshow: this.isshow, question: item.question})
        })
      })
    },
    determine()
    {
      this.isShowZX = false
      this.isshowLXFS = true
    },
    submit()
    {
      let uname = localStorage.getItem('username')
      let quesoption = {}
      this.checkList1.forEach((item, index) =>
      {
        quesoption[index + 1] = item.value
      })
      let param = {
        cmd: 'add',
        _major: 11,
        _minor: 124,
        qsoption: JSON.stringify(quesoption),
        username: uname,
        jtwt: this.form.jtwt,
        type: 2,
        contact: this.form.contact,
        date: Date.parse(new Date()) / 1000
      }
      window.post.getPost(param).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '提交失败', type: 'error', customClass: 'mzindex'})
        else
        {
          let paras = {
            cmd: 'consultation',
            _major: 99,
            _minor: 4,
            name: uname,
            phone: this.userPhone
          }
          window.post.getDmSvr(paras).then((ret) =>
          {
            if (ret.ret === 0)
            {
              this.$message({message: '提交成功！管理员会尽快予以回复，请您耐心等待', type: 'success', customClass: 'mzindex'})
              this.checkList1 = []
              this.checkList = []
              this.zxfw[0].isshow = true
              this.isShowZX = true
              this.isshowLXFS = false
              this.zxfw[this.zxfw.length - 1].isshow = false
              this.$parent.openFlfws()
            }
            else
            
              this.$message({message: '短信发送失败', type: 'error', customClass: 'mzindex'})
          })
        }
      })
    },
    onSaveData(val, index)
    {
      this.checkList1[index] = val
    },
    onDisnear()
    {
      this.checkList1 = []
      this.checkList = []
      this.zxfw.forEach((item, index) =>
      {
        if (item.isshow === true)
          this.zxfw[index].isshow = false
      })
      this.zxfw[0].isshow = true
      this.$parent.openFlfws()
    },
    onDisnears()
    {
      this.checkList1 = []
      this.checkList = []
      this.isShowZX = true
      this.isshowLXFS = false
      this.zxfw[this.zxfw.length - 1].isshow = false
      this.zxfw[0].isshow = true
      this.$parent.openFlfws()
    },
    cancel()
    {
      this.isShowZX = true
      this.isshowLXFS = false
      this.checkList1 = []
      this.checkList = []
      this.zxfw[0].isshow = true
      this.zxfw[this.zxfw.length - 1].isshow = false
      this.isShowZX = true
      this.isshowLXFS = false
      this.$parent.openFlfws()
    },
    onClicktop(index)
    {
      this.zxfw[index - 1].isshow = true
      this.zxfw[index].isshow = false
    },
    onClickBottom(index)
    {
      let self = this
      self.zxfw[index].isshow = false
      self.zxfw[index + 1].isshow = true
    },
    handleCheckedCitiesChange(value, index)
    {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.zxfw[index].centry.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.zxfw[index].centry.length
    }
    // handleCheckAllChange(val, index)
    // {
    //   debugger
    //   console.log(val)
    //   this.checkList = val ? this.zxfw[index].centry : []
    //   this.isIndeterminate = false
    // },
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/LegalService.vue